<footer class="pt-5 pb-4" style="background-color: black">
  <div class="footer-upper pb-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 pe-4">
          <div class="footer-about">
            <a class="logo" routerLink="/" routerLinkActive="active">
              <img
                src="assets/images/lhd/LUXURY white.png"
                class="logo-img"
                alt="Luxury Holidays Direct"
                width="100%"
                height="100px"
                loading="lazy"
              />
            </a>
            <ul style="margin-left: -32px">
              <li class="white">
                <strong>Call Us&nbsp;:</strong
                ><a href="tel:02087747298"> 020 8774 7298</a>
              </li>
              <li class="white">
                <strong>Email Us&nbsp;:</strong>
                <span class="emailfont"
                  ><a href="mailto:enquiries@luxuryholidaysdirect.com">
                    enquiries@luxuryholidaysdirect.com</a
                  ></span
                >
              </li>
              <li class="white">
                <strong>Website&nbsp;:</strong
                ><a routerLink="/"> www.luxuryholidaysdirect.com </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
          <div class="footer-links">
            <br />
            <span class="white font3 font5 custom-title">Quick links</span>
            <ul class="marg-ul" style="margin-left: -32px">
              <li><a routerLink="/about-us">About Us</a></li>
              <li><a routerLink="/contact-us">Contact Us</a></li>
              <li><a routerLink="/travelwise">Travel Wise</a></li>
              <li><a routerLink="/request-quote">Request Quote</a></li>
              <li><a routerLink="/blog">Travel Blog</a></li>
              <li><a routerLink="/offers-deals">Offers & Deals</a></li>
              <li><a routerLink="/tours">Tours</a></li>
              <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
              <li>
                <a routerLink="/booking-conditions">Booking Conditions</a>
              </li>
              <!-- <li>
                <a routerLink="/blackfriday-conditions" target="_blank" rel="noopener noreferrer"
                  >Black Friday T&C</a
                >
              </li> -->
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
          <div class="footer-links">
            <span class="white custom-title">TOP LUXURY DESTINATIONS</span>
            <ul class="marg-ul" style="margin-left: -32px">
              <li>
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-maldives',
                    3,
                  ]"
                  >Maldives</a
                >
              </li>
              <li>
                <a [routerLink]="['/destinations', 'luxury-hotels-in-dubai', 6]"
                  >Dubai</a
                >
              </li>
              <li>
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-mauritius',
                    1,
                  ]"
                  >Mauritius</a
                >
              </li>
              <li>
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-seychelles',
                    2,
                  ]"
                  >Seychelles</a
                >
              </li>
              <li>
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-thailand',
                    33,
                  ]"
                  >Thailand</a
                >
              </li>
            </ul>
            <!-- SEO FIX: Added theme links for internal link equity -->
            <span class="white custom-title" style="margin-top: 10px; display: block;">BROWSE BY THEME</span>
            <ul class="marg-ul" style="margin-left: -32px">
              <li><a routerLink="/themes/honeymoon">Honeymoon</a></li>
              <li><a routerLink="/themes/beachholidays">Beach Holidays</a></li>
              <li><a routerLink="/themes/friendsfamily">Family Holidays</a></li>
              <li><a routerLink="/themes/allinclusive">All Inclusive</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
          <div class="footer-links">
            <span class="white font3 custom-title">RECOMMENDED HOTELS</span>
            <div class="newsletter-form marg-ul">
              <p class="mb-3 white1">
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-mauritius',
                    'the-westin-mauritius-turtle-bay-resort-spa',
                    7018,
                  ]"
                  >The Westin Mauritius Turtle Bay Resort & Spa</a
                >
              </p>
              <p class="mb-3 white1">
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-mauritius',
                    'the-residence-mauritius',
                    5082,
                  ]"
                  >The Residence Mauritius</a
                >
              </p>
              <p class="mb-3 white1">
                <a
                  [routerLink]="[
                    '/destinations',
                    'luxury-hotels-in-mauritius',
                    'constance-le-prince-maurice',
                    5067,
                  ]"
                  >Constance Le Prince Maurice</a
                >
              </p>
              <form
                action="#"
                method="get"
                accept-charset="utf-8"
                class="border-0 d-flex align-items-center"
              >
                <!-- <input type="text" placeholder="Email Address"> -->
                <a routerLink="/subscribe" class="nir-btn ms-2">Subscribe</a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-copyright">
    <div class="container">
      <div
        class="copyright-inner rounded p-3 d-md-flex align-items-center justify-content-between"
      >
        <div class="copyright-text">
          <p class="m-0 white">
            2026 Luxury Holidays Direct. All rights reserved.
          </p>
        </div>
        <div class="social-links">
          <ul>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61581114635348"
                target="_blank" rel="noopener noreferrer"
                aria-label="facebook"
              >
                <fa-icon [icon]="faFacebook" color="white"></fa-icon>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/luxuryholidaysdirect/"
                target="_blank" rel="noopener noreferrer"
                aria-label="instagram"
              >
                <fa-icon [icon]="faInstagram" color="white"></fa-icon>
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@luxury.holidays.d?_t=ZM-9039F1MWT8d&_r=1"
                target="_blank" rel="noopener noreferrer"
                aria-label="tiktok"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  width="14"
                  viewBox="0 0 640 640"
                >
                  <path
                    fill="#ffffff"
                    d="M544.5 273.9C500.5 274 457.5 260.3 421.7 234.7L421.7 413.4C421.7 446.5 411.6 478.8 392.7 506C373.8 533.2 347.1 554 316.1 565.6C285.1 577.2 251.3 579.1 219.2 570.9C187.1 562.7 158.3 545 136.5 520.1C114.7 495.2 101.2 464.1 97.5 431.2C93.8 398.3 100.4 365.1 116.1 336C131.8 306.9 156.1 283.3 185.7 268.3C215.3 253.3 248.6 247.8 281.4 252.3L281.4 342.2C266.4 337.5 250.3 337.6 235.4 342.6C220.5 347.6 207.5 357.2 198.4 369.9C189.3 382.6 184.4 398 184.5 413.8C184.6 429.6 189.7 444.8 199 457.5C208.3 470.2 221.4 479.6 236.4 484.4C251.4 489.2 267.5 489.2 282.4 484.3C297.3 479.4 310.4 469.9 319.6 457.2C328.8 444.5 333.8 429.1 333.8 413.4L333.8 64L421.8 64C421.7 71.4 422.4 78.9 423.7 86.2C426.8 102.5 433.1 118.1 442.4 131.9C451.7 145.7 463.7 157.5 477.6 166.5C497.5 179.6 520.8 186.6 544.6 186.6L544.6 274z"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/Luxuryholidaysdirect1?app=desktop"
                target="_blank" rel="noopener noreferrer"
                aria-label="youtube"
              >
                <fa-icon [icon]="faYoutube" color="white"></fa-icon>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/luxuryholidaysd?lang=en"
                target="_blank" rel="noopener noreferrer"
                aria-label="twitter"
              >
                <!-- <fa-icon [icon]="faTwitter" color="white"></fa-icon> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  width="14"
                  viewBox="0 0 640 640"
                >
                  <path
                    fill="#ffffff"
                    d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="particles-js"></div>
</footer>
